import { Table, TableColumnType, TextHeader } from '@eltoro-ui/components'
import { usePagination } from '@eltoro-ui/hooks'
import { V1CreativeSearch } from 'next-gen-sdk'
import { EmptyField, TablePagination } from 'Components'
import { getCreativeFaETIcons, simplifyEnum } from 'Helpers'
import { creativeStatusOptions, creativeTypeOptions } from 'searchOptions'
import { OrgNameCell } from '../../OrgNameCell'

const searchCreativeTableColumns: TableColumnType<V1CreativeSearch>[] = [
  {
    path: 'name',
    label: 'Name',
    filterOn: 'string',
    RowCell: ({ type, name }) => (
      <div className="flex items-center">
        {getCreativeFaETIcons(type || undefined)}
        <span className="ml-1">{name}</span>
      </div>
    ),
  },
  {
    path: 'type',
    label: 'Type',
    filterOn: creativeTypeOptions,
    RowCell: ({ type }) => (type ? simplifyEnum(2, type) : <EmptyField />),
  },
  {
    path: 'status',
    label: 'Status',
    filterOn: creativeStatusOptions,
    RowCell: ({ status }) =>
      status ? simplifyEnum(2, status) : <EmptyField />,
  },
  {
    path: 'orgId',
    label: 'Source Org',
    removeFilter: true,
    RowCell: ({ orgLogo, orgName }) =>
      orgName ? <OrgNameCell name={orgName} logo={orgLogo} /> : <EmptyField />,
  },
  {
    path: 'creativeId',
    label: 'ID',
    removeFilter: true,
  },
]

export const SearchCreativeTable: React.FC<{
  results: V1CreativeSearch[]
  handleRowClick: (clicked: V1CreativeSearch) => void
}> = ({ results, handleRowClick }) => {
  const creativePagination = usePagination<V1CreativeSearch>({
    pageSize: 5,
    sourceData: results,
  })

  if (!results.length) return null

  return (
    <div className="SearchCreativeTable">
      <TextHeader type={4} className="SearchCreativeTable__header mt-4">
        Creatives ({results.length})
      </TextHeader>
      <div className="p-4">
        {creativePagination.data && (
          <>
            <Table
              columns={searchCreativeTableColumns}
              rows={creativePagination.data}
              onClick={(creative) => handleRowClick(creative)}
            />
            <div className="flex justify-end pt-2">
              <TablePagination pagination={creativePagination} />
            </div>
          </>
        )}
      </div>
    </div>
  )
}
